module.exports = __webpack_public_path__ + "static/media/chyngex-transparent.ed6988f7.png";